const ORIGINAL_VALUES = Symbol('ORIGINAL_VALUES');

interface Identifiable {
  id: string | number;
}

type Reversible<T> = T & { [ORIGINAL_VALUES]?: Partial<T> };

export const applyReversibleUpdate = <T extends Identifiable>(
  collection: T[],
  id: T['id'],
  update: Partial<T>,
): void => {
  const record = collection.find((item) => item.id === id) as Reversible<T> | undefined;
  if (record) {
    if (!record[ORIGINAL_VALUES]) {
      record[ORIGINAL_VALUES] = {};
    }
    const originalValues = record[ORIGINAL_VALUES];
    const originalKeys = Object.keys(originalValues);
    (Object.entries(update) as [keyof T, T[keyof T]][]).forEach(([key, value]) => {
      if (!originalKeys.includes(key as string)) {
        originalValues[key] = record[key];
      }
      record[key] = value;
    });
  }
};

export const reverseUpdate = <T extends Identifiable>(collection: T[], id: T['id']): void => {
  const record = collection.find((item) => item.id === id) as Reversible<T> | undefined;
  if (record) {
    (Object.entries(record[ORIGINAL_VALUES] ?? {}) as [keyof T, T[keyof T]][]).forEach(
      ([key, value]) => {
        record[key] = value;
      },
    );
    delete record[ORIGINAL_VALUES];
  }
};
